import { jsx as _jsx } from "react/jsx-runtime";
import { Backdrop } from '../../atoms/Backdrop';
import { Card } from '../Card';
import { LogoLoader } from './LogoLoader';
export function LogoLoaderWithBackdrop({ open, title = '', }) {
    return (_jsx(Backdrop, { open: open, children: _jsx(Card, { title: title, children: _jsx(LogoLoader, {}) }) }));
}
